// extracted by mini-css-extract-plugin
export default {"enter":"ModalAnimation_enter__SBye6","enterActive":"ModalAnimation_enterActive__poLjX","exit":"ModalAnimation_exit__rXINj","exitActive":"ModalAnimation_exitActive__tnJ8b"};